require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./companies.json") })
        }
      }, "path---companies");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---companies!./.cache/json/companies.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---companies!./.cache/json/companies.json
// module chunks = 231608221292675